<template>
  <validation-observer
    ref="requestServiceReconsideration"
    v-slot="{}"
    tag="form"
  >
    <div class="row">
      <div class="col-12 mb-1">
        <label class="color-gray-7 font-16 font-weight-bold">
          <i class="fas fa-reply-all gold-orange mr-1" />
          Solicitud de Reconsideración:
        </label>
      </div>
    </div>
    <div class="col-12 mt-3">
      <validation-provider
        v-slot="{ errors }"
        name="reconsiderationComment"
        rules="required"
      >
        <label class="data-title mb-0">Comentario:</label>
        <custom-text-area
          v-model="model.comment"
          :count-classes="['float-right']"
          custom-error-msg="El comentario es requerido."
          :error="errors[0]"
          :maxlength="3000"
          show-char-count
        />
      </validation-provider>
    </div>
    <div v-if="!isReadOnly" class="col-12 mt-3 pt-4">
      <div class="d-flex flex-row-reverse bd-highlight w-100 actions">
        <div class="bd-highlight ml-2">
          <action-button
            i="fas  fa-save fa-lg"
            text="Guardar"
            variant="success"
            @click="onSave"
          />
        </div>
        <div class="mx-0 bd-highlight">
          <action-button
            id="modal-btn-cancelar"
            i="fas fa-times-circle"
            text="Cancelar"
            variant="outline-danger"
            @click="$emit('cancel')"
          />
        </div>
      </div>
    </div>
  </validation-observer>
</template>

<script>
import CustomTextArea from 'CustomTextArea';
import ActionButton from 'ActionButton';
import alert from '@quisit/mipe-utils/mixins/alert.mixin.js';

import { requestServiceReconsideration } from '@/services/uspqrp/provisional-remedy.api';

export default {
  name: 'RequestServiceReconsideration',
  mixins: [alert],
  components: {
    CustomTextArea,
    ActionButton,
  },
  props: {
    data: {
      type: Object,
      required: true,
      default: () => {},
    },
    isReadOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      model: {
        comment: null,
      },
    };
  },
  methods: {
    async onSave() {
      const isValid = await this.$refs.requestServiceReconsideration.validate();
      if (!isValid) {
        this.ShowToast(
          'Alerta',
          'Favor completar la información de cancelación solicitada.',
          'error'
        );
        return;
      }

      const answer = await this.ShowCancelModal(
        'Confirmación',
        `¿Está seguro que desea solicitar reconsideración para la solicitud ${this.data.requestNumber}?`,
        'Sí',
        'No'
      );
      if (answer) {
        const payload = {
          requestId: this.data.requestId,
          requestServiceId: this.data.requestServiceId,
          comment: this.model.comment,
        };

        await requestServiceReconsideration(payload)
          .then(async () => {
            this.ShowToast(
              'Confirmación',
              'La solicitud de reconsideración se ha sometido exitosamente.',
              'success'
            );
            this.$emit('save', true);
          })
          .catch((error) => {
            this.ShowToast('Alerta', `${error.message}.`, 'error');
          });
      }
    },
  },
};
</script>

<style scoped>
.fa-circle {
  filter: drop-shadow(20px 10px 1px red);
}
</style>
